// extracted by mini-css-extract-plugin
export default {"img":"icon_img__8npvy"};